import { ILectors } from './data'

const AVATAR_HALF_WIDTH = 27.5
const MAX_AVATAR_COUNT = 3
const EMPTY_FLAG = 'empty'

const prepareLecturs = (lecturs: ILectors[], lecturName: string | undefined) => {
  const formatLecturs = lecturName
    ? lecturName.split(',').map((lectur) => ({ name: lectur.trim(), img: undefined }))
    : []
  const allLecturs = [...lecturs, ...formatLecturs]
  const count = allLecturs.length
  const restLectursCount = count - MAX_AVATAR_COUNT

  const shrinkedLecturs =
    count > MAX_AVATAR_COUNT ? allLecturs.slice(0, MAX_AVATAR_COUNT) : allLecturs

  if (count > MAX_AVATAR_COUNT) shrinkedLecturs.push({ name: EMPTY_FLAG, img: undefined })

  return { allLecturs, count, shrinkedLecturs, restLectursCount }
}

export { AVATAR_HALF_WIDTH, EMPTY_FLAG, MAX_AVATAR_COUNT, prepareLecturs }
